import React from 'react';
import { Button } from '@mui/material';
import BaseModal from '../../../shared/components/base.modal';

interface ConfirmTestModalProps {
  open: boolean;
  handleYes: () => void;
  handleNo: () => void;
}

const ConfirmTestModal: React.FC<ConfirmTestModalProps> = ({ open, handleYes, handleNo }) => {
  return (
    <BaseModal open={open} handleClose={handleNo}>
      <h2 className="fw-bold my-3">Post a Test Transaction</h2>
      <img alt={'Logo'} src="/logo120.svg" />
      <p className="my-5">
        Posting a test transaction creates a real journal entry in QuickBooks, numbered TEST-(prefix). It is
        calculated and dated as the next scheduled posting would be, using the books as they are today, so a period
        that isn't over yet may be incomplete. Delete test entries in QuickBooks after reviewing. Are you sure you want
        to post a test transaction?
      </p>
      <div className="d-flex justify-content-between my-3">
        <Button onClick={handleNo} variant="outlined" sx={{ mt: 2, width: '136px' }}>
          No
        </Button>
        <Button onClick={handleYes} variant="contained" sx={{ mt: 2, width: '136px' }}>
          Yes
        </Button>
      </div>
    </BaseModal>
  );
};

export default ConfirmTestModal;
